export const ordersGroupsPaymentStatusCodes = {
    nop: "Ninguna orden pagada",
    aop: "Todas las ordenes pagadas",
    sop: "Algunas ordenes pagadas"
};

export const ordersGroupsPaymentStatusMessageClass = {
    nop: "text-theme-warning",
    aop: "text-success",
    sop: "text-info"
};
